/** Fields collected on the Remitter Details screen. */
export const REMITTER_REQUIRED_FIELDS = [
  "dob",
  "gender",
  "nationality",
  "addressLine1",
  "addressLine2",
  "city",
  "state",
  "pinCode",
  "employmentStatus",
  "incomeRange",
  "residentStatus",
] as const;

export const isRemitterDetailsIncomplete = (details: any): boolean => {
  if (!details) return true;

  return REMITTER_REQUIRED_FIELDS.some((field) => {
    const value = details?.[field];
    return value === null || value === undefined || value === "";
  });
};
